export default __webpack_public_path__ + "static/media/VALAS.0499921d.svg";